import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from "@angular/router";
import { AuthService } from "./services/auth.service";
import { Subscription } from "rxjs";
import { LocalStorageService } from "./services/local-storage.service";
import { FirestoreService } from "./services/firestore.service";
import { DataSharingService } from "./services/data-sharing.service";
import { SettingsService } from "./services/settings.service";
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { MyEvent } from './services/myevent.services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Admin';

  valor: string;
  valorSubscription: Subscription;
  sub: Subscription;

  collectionName = 'Settings';
  collectionField = 'settings_lastupdateday';
  orderByDir: any = 'asc';

  constructor(
    private router: Router,
    private auth: AuthService,
    private variablesLocales: LocalStorageService,
    private firestore: FirestoreService,
    private dataSharing: DataSharingService,
    private settingsService: SettingsService,
    private translate: TranslateService,
    private myEvent: MyEvent,
    private titleService: Title
  ) {
    // Escuchar cambios desde Firestore y forzar recarga de settings
    this.sub = this.firestore.search(this.collectionName, {
      'orderByName': this.collectionField,
      'orderByDir': this.orderByDir,
    }).subscribe(() => {
      this.settingsService.loadGeneralSettings(true).subscribe();
    });

    this.valorSubscription = this.variablesLocales.getValorObservable('typeBusiness').subscribe(
      (valor: string) => {
        this.valor = valor;
      }
    );

    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|es/) ? browserLang : 'en');
  }

  ngOnInit(): void {
    this.titleService.setTitle(environment.appTitle);
    const favicon = document.getElementById('app-favicon') as HTMLLinkElement;
    if (favicon) favicon.href = environment.favicon;

    if (environment.features.googleMaps && environment.googleMapsKey) {
      const script = document.createElement('script');
      script.src = `https://maps.google.com/maps/api/js?key=${environment.googleMapsKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  globalize(languagePriority) {
    this.translate.setDefaultLang("es");
    let defaultLangCode = environment.default_language;
    this.translate.use(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.valorSubscription?.unsubscribe();
  }
}